// NOTE: Any config values shared in here will be publicly available to a client.
// Do not include any config values in here that should be secured.

// Config values shared between environments go in here
const common = {}

const development = {
  firebase: {
    apiKey: 'AIzaSyC59YrtKOy-tYsTCTeWpzMv2htgOpooKL8',
    authDomain: 'piccles-coloring-development.firebaseapp.com',
    databaseURL: 'https://piccles-coloring-development.firebaseio.com',
    projectId: 'piccles-coloring-development',
    storageBucket: 'piccles-coloring-development.appspot.com',
    messagingSenderId: '511467375167',
  },
  cloudFunctionBaseUrl: 'https://us-central1-piccles-coloring-development.cloudfunctions.net/app',
  googleAnalyticsId: 'UA-122679900-1',
}

const production = {
  firebase: {
    apiKey: 'AIzaSyAxg2bP_t3uSIKVNvPW0OtbN79Cq3p34g0',
    authDomain: 'picclescoloring.firebaseapp.com',
    databaseURL: 'https://picclescoloring.firebaseio.com',
    projectId: 'picclescoloring',
    storageBucket: 'picclescoloring.appspot.com',
    messagingSenderId: '682681569226',
  },
  cloudFunctionBaseUrl: 'https://us-central1-picclescoloring.cloudfunctions.net/app',
  googleAnalyticsId: 'UA-118165346-1',
}

const config = process.env.REACT_APP_ENV === 'development' ? development : production

window.config = config

export default {
  ...common,
  ...config,
}



// WEBPACK FOOTER //
// ./src/config.js